import { apiPost } from "./client";

export function insertStripeCustomerPaymentMethod(payload) {
  return apiPost("/stripe/insert-stripe-cus-pm", payload);
}

export function manageSubscriptionSchedule(payload) {
  return apiPost("/stripe/manage-subscription-schedule", payload);
}
